import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { styled, Box, useTheme } from '@mui/system'
import {
    Icon,
    Badge,
    Card,
    Button,
    IconButton,
    Drawer,
    Avatar,
    Typography,
    TextField,
    MenuItem,
    Grid,
    Divider,
} from '@mui/material'
import axios from 'axios'
import { useEffect } from 'react'
import { v4 as uuidv4 } from "uuid";
import NotificationsIcon from '@mui/icons-material/Notifications';
import ClearIcon from '@mui/icons-material/Clear';
import { useDispatch, useSelector } from 'react-redux'
import { getNotifications } from '../../actions/actions'
import { dateConversion } from '../../component/reusableComponent/dateConversionOnEntryPage'
// import { basicURL } from './../../Authconfig';

const Notification = styled('div')(() => ({
    padding: '16px',
    marginBottom: '15px',
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    height: 58,
    borderBottom: '1px solid #bfbfbf',
    // boxShadow: themeShadows[6],
    '& h5': {
        marginLeft: '8px',
        marginTop: 0,
        marginBottom: 0,
        fontWeight: '500',
    },
}))

const NotificationCard = styled(Box)(({ theme }) => ({
    position: 'relative',
    '& .messageTime': {
        color: '#86868b',
        fontSize: '14px',
        marginTop: '3px',
        float: 'right'
    },
    '& .icon': { fontSize: '1.25rem' },
}))


const CardLeftContent = styled('div')(() => ({
    padding: '12px 8px',
    // background: '#f4f6f9',
    '& small': {
        fontWeight: '500',
        marginLeft: '16px',
        color: '#86868b',
    },
}))


const NotificationBar = ({ container }) => {
    const theme = useTheme()
    const [panelOpen, setPanelOpen] = React.useState(false)
    const [isUpdateArray, setIsUpdateArray] = React.useState(false);

    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;

    const dispatch = useDispatch();

    const notifications = useSelector(state => state.notifications.notifications)

    const fetchData = () => {
        dispatch(getNotifications({ companyId: userInfo.companyId }))
    };

    useEffect(() => {
        fetchData()
    }, []);


    const handleDrawerToggle = () => {
        setPanelOpen(!panelOpen)
    }


    return (
        <Fragment>
            <IconButton onClick={handleDrawerToggle} style={{ paddingRight: '10px' }}>
                <Badge color="error" badgeContent={notifications && notifications.length}>
                    <NotificationsIcon sx={{ color: '#FFFFFF' }}></NotificationsIcon>
                </Badge>
            </IconButton>

            <Drawer
                container={container}
                variant="temporary"
                anchor={'right'}
                open={panelOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true,
                }}
            >
                <Box >
                    <Notification >
                        <Grid container spacing={2} >
                            <Grid item sx={1} md={1} xs={1}>
                                <NotificationsIcon style={{ color: "#ff0000",  }}></NotificationsIcon>
                            </Grid>
                            <Grid item sx={10} md={10} xs={10}>
                                <Typography style={{ fontSize: '16px', marginLeft:'12px', fontWeight: 600, }}>All Notifications </Typography>
                            </Grid>
                            <Grid item sx={1} md={1} xs={1}>
                                <ClearIcon color="error" onClick={handleDrawerToggle} style={{ fontSize: '20px', fontWeight: 600, float: 'right', cursor: 'pointer' }} />
                            </Grid>
                        </Grid>
                    </Notification>
                   
                    {notifications && notifications.map((alt, index) => (
                        <NotificationCard >
                            <Card sx={{ mx: 2, mb: 2 }} elevation={3} style={{backgroundColor: alt.CNS_Type === 'Supplier' ?'#ffe6e6' : '#e6e6ff'}}>
                                <CardLeftContent>
                                    <Box style={{ display: 'flex',alignItems: 'center',justifyContent: 'space-between',}}>
                                       <Typography style={{fontSize: '12px',fontWeight: 500}}>Invoice No: <span style={{fontWeight: 600, fontSize: '14px'}}>{alt.invoiceNo}</span></Typography>
                                       <Typography style={{fontSize: '12px',fontWeight: 500}}>Date: {dateConversion(alt.invoiceDate)}</Typography>
                                    </Box>
                                    <Box>
                                        <Typography style={{fontSize: '12px',fontWeight: 500}}>{alt.CNS_Type === 'Supplier' ? 'Supplier Name:' : 'Customer Name'} {alt.CNS_Name}</Typography>
                                        <Typography style={{fontSize: '12px',fontWeight: 500}}>Invoice Amount: <span style={{color: alt.CNS_Type === 'Supplier' ?'#cc0000' : '#0000cc', fontWeight: 600, fontSize: '14px'}}>{parseFloat(Math.round(alt.invoiceAmount)).toFixed(2)}</span></Typography>
                                    </Box>
                                </CardLeftContent>
                            </Card>
                        </NotificationCard>
                    ))}

                </Box>
            </Drawer>
        </Fragment>
    )
}

export default NotificationBar
